var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUndelivered = function SvgUndelivered(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 10,
    fill: "#E85C4A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.5 13h-1V9.619l-3.964 3.55L8.5 9.608V15.5H14v1H8a.5.5 0 01-.5-.5V8a.5.5 0 01.5-.5h9a.5.5 0 01.5.5v5zM8.755 8.5l3.775 3.331L16.252 8.5H8.755zm8.452 7l1.061 1.06-.707.708-1.061-1.061-1.06 1.061-.708-.707 1.061-1.061-1.061-1.06.708-.708 1.06 1.061 1.06-1.061.708.708-1.061 1.06z"
  })));
};
export default SvgUndelivered;